import { GET_APPS } from '../Constants/applications.constants';

const initalState = {
    allApps: []
};

export default (state = initalState, action) => {
    switch (action.type) {
        case GET_APPS:
            return {
                ...state,
                allApps: action.data
            };
        default:
            return state;
    }
};
